import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Play, History } from "lucide-react";
import { readHistory, clearHistory, formatPos } from "../watchHistory";

/** «Продолжить просмотр»: последние открытые материалы с места, где зритель остановился (по «Содержанию»). */
export default function ContinueWatching({ limit = 4 }) {
  const [items, setItems] = useState(() => readHistory().slice(0, limit));
  if (!items.length) return null;

  const clear = () => { clearHistory(); setItems([]); };
  return (
    <div className="continue" aria-label="Продолжить просмотр">
      <div className="continue-head">
        <span className="continue-title"><History size={16} strokeWidth={2.2} /> Продолжить просмотр</span>
        <button type="button" className="continue-clear" onClick={clear}>очистить</button>
      </div>
      <div className="continue-row">
        {items.map(i => (
          <Link key={i.id} to={`/lectures/${i.id}${i.pos ? `?t=${i.pos}` : ""}`} className="continue-card">
            <span className="continue-thumb">
              {i.thumbnail_url ? <img src={i.thumbnail_url} alt="" loading="lazy" /> : <span className="lecture-thumb-fallback" />}
              <span className="lecture-play"><Play size={18} fill="currentColor" strokeWidth={0} /></span>
            </span>
            <span className="continue-name">{i.title}</span>
            <span className="continue-sub">
              {i.pos ? `с ${formatPos(i.pos)}${i.chapter ? ` · ${i.chapter}` : ""}` : (i.duration || "Смотреть")}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
